import img from "../US_img/34Plafond architectural moderne.webp"; // adapte le chemin image
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsLightDecoratif() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });

    
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>LIGHT</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Solutions lumineuses décoratives</h1>

          <p data-aos="fade-up">
            Plafonds et murs lumineux sur mesure pour créer des ambiances
            décoratives uniques dans les hôtels, restaurants, commerces
            et espaces résidentiels.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-light-decoratif.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Light plafond décoratif lumineux" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US LIGHT décoratif ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US LIGHT décoratif permet la création de plafonds et murs lumineux
            personnalisés pour transformer les espaces en environnements
            visuellement attractifs et immersifs.
          </p>

          <p data-aos="fade-up">
            Grâce à l’intégration de toiles lumineuses et de systèmes LED,
            cette solution offre une grande liberté de design et des
            ambiances sur mesure.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="🌈"
            title="Ambiances personnalisées"
            text="Création d’effets lumineux sur mesure."
          />
          <Feature
            icon="🎨"
            title="Design décoratif"
            text="Intégration esthétique dans tous types d’espaces."
          />
          <Feature
            icon="💡"
            title="Lumière douce"
            text="Diffusion homogène et confortable."
          />
          <Feature
            icon="🏨"
            title="Idéal lieux premium"
            text="Parfait pour hôtels, spas, restaurants et commerces."
          />
          <Feature
            icon="⚡"
            title="LED économiques"
            text="Faible consommation et longue durée de vie."
          />
          <Feature
            icon="🛠️"
            title="Installation propre"
            text="Pose rapide et sans travaux lourds."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Toiles lumineuses personnalisables</li>
          <li>Systèmes LED intégrés</li>
          <li>Diffusion homogène sans éblouissement</li>
          <li>Possibilité d’effets lumineux et couleurs</li>
          <li>Structure aluminium technique</li>
          <li>Compatible plafonds et murs décoratifs</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Hôtels",
            "Spas",
            "Restaurants",
            "Commerces",
            "Bars & lounges",
            "Espaces résidentiels",
            "Centres commerciaux",
            "Espaces événementiels",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Créez une ambiance lumineuse unique</h2>
        <p>Nos solutions US LIGHT décoratives s’adaptent à votre identité visuelle.</p><br/>
        <a href="/contact" className="btn-primarya">Contactez-nous</a>
      </section>

    </div>
  );
}
